import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Drag = props => {
  const $ = _c(8);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="7.5" cy="4.16667" r="1.66667" fill="currentColor" />;
    t1 = <circle cx="12.5" cy="4.16667" r="1.66667" fill="currentColor" />;
    t2 = <circle cx="7.5" cy="10" r="1.66667" fill="currentColor" />;
    t3 = <circle cx="12.5" cy="10" r="1.66667" fill="currentColor" />;
    t4 = <circle cx="7.5" cy="15.8333" r="1.66667" fill="currentColor" />;
    t5 = <circle cx="12.5" cy="15.8333" r="1.66667" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props) {
    t6 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}</svg>;
    $[6] = props;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default Drag;